/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {isAuthorizedUser, userHasMainScope} from '../../../../../../app/routing/utils/permissions'
import {useAuth} from '../../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()

  const {currentUser} = useAuth()

  return (
    <>
      <SidebarMenuItem
        to='/kpi/dashboard'
        icon='home'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      {userHasMainScope(currentUser, ['kpi']) && (
        <SidebarMenuItemWithSub
          to='/reports'
          title='Relatórios'
          fontIcon='bi-archive'
          icon='graph-up'
        >
          {isAuthorizedUser(currentUser, 'kpi.sales') && (
            <SidebarMenuItem to='reports/reportSale/list' title='Vendas' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'kpi.bonus_sales') && (
            <SidebarMenuItem to='reports/reportBonusSale/list' title='Vendas Bonus' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'kpi.salesman') && (
            <SidebarMenuItem to='reports/reportUser/list' title='Meta de Vendas' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'kpi.customers') && (
            <SidebarMenuItem to='reports/reportCliente/list' title='Clientes' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'kpi.transfers') && (
            <SidebarMenuItem
              to='reports/reportTransfer/list'
              title='Transferência'
              hasBullet={true}
            />
          )}
          {isAuthorizedUser(currentUser, 'kpi.summary') && (
            <SidebarMenuItem to='reports/reportSummary/list' title='Resumo' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'kpi.recurrence') && (
            <SidebarMenuItem
              to='reports/reportRecurrence/list'
              title='Recorrência'
              hasBullet={true}
            />
          )}
          {isAuthorizedUser(currentUser, 'kpi.export') && (
            <SidebarMenuItem to='reports/downloads' title='Downloads' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}
    </>
  )
}

export {SidebarMenuMain}
